import React from "react";
import { ArrowDownToLineIcon, Clock, Edit, Eye } from "lucide-react";

export default function FacturasTableComponent({
  data = [],
  metaPaginacion = {},
  onPageChange,
  perPage = 10,
  onPerPageChange,
  handleEditarItem,
  handleVerObsequio,
  handleOpenModalDeleteEvento,
  handleOpenModalExcel
}) {

  const formatDate = (value) => {
    if (!value) return "-";

    const date = new Date(value);
    if (Number.isNaN(date.getTime())) return "-";

    return new Intl.DateTimeFormat("es-PY", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
    }).format(date);
  };


  return (
    <div className="bg-white rounded-xl border border-gray-200 overflow-hidden">
      {/* Header de la tabla */}
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-gray-50 border-b border-gray-200">
            <tr>
              <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Cliente
              </th>

              <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Título
              </th>
              <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Imagen
              </th>
              <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Vigencia
              </th>

              {/* <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Monto mínimo
              </th> */}

              {/* <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Stock
              </th> */}

              {/* <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Estado
              </th> */}

              <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Activo
              </th>

              <th className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                Acciones
              </th>
            </tr>
          </thead>
          <tbody className="bg-white divide-y divide-gray-200">
            {data?.map((item) => (
              <tr key={item.id} className="hover:bg-gray-50 transition-colors">
                <td className="px-6 py-4">
                  <div className="flex items-center gap-3">
                    <div>
                      <div className="font-medium text-gray-900">{item?.usuario?.user?.first_name} {item?.usuario?.user?.last_name}</div>
                      <div className="text-sm text-gray-500">{item?.usuario?.user?.email || "-"}</div>
                      <div className="text-sm text-gray-500">{item?.usuario?.ci || "-"}</div>
                    </div>
                  </div>
                </td>

                <td className="px-6 py-4">
                  <div className="flex items-center gap-3">
                    <div>
                      <div className="font-medium text-gray-900">{item?.obsequio?.titulo}</div>
                      {/* <div className="text-sm text-gray-500">{item?.slug || "-"}</div> */}
                    </div>
                  </div>
                </td>

                <td className="px-6 py-4 whitespace-nowrap">
                  {item?.imagen_url || item?.imagen ? (
                    <img
                      src={item?.imagen_url || item?.imagen}
                      alt={item.titulo}
                      className="w-16 h-16 object-cover rounded"
                    />
                  ) : (
                    <div className="w-16 h-16 bg-gray-200 rounded flex items-center justify-center text-gray-500 text-sm">
                      Sin imagen
                    </div>
                  )}
                </td>

                <td className="px-6 py-4">
                  {item?.obsequio?.fecha_inicio || item?.obsequio?.fecha_fin ? (
                    <div className="flex flex-col gap-1 text-sm text-gray-600">
                      <div className="flex items-center gap-1">
                        <Clock className="w-4 h-4" />
                        <span>Inicio: {formatDate(item?.obsequio?.fecha_inicio)}</span>
                      </div>
                      <div className="flex items-center gap-1 text-gray-500">
                        <Clock className="w-4 h-4" />
                        <span>Fin: {formatDate(item?.obsequio?.fecha_fin)}</span>
                      </div>
                    </div>
                  ) : (
                    <div className="text-sm text-gray-500">Sin vigencia</div>
                  )}
                </td>

                {/* <td className="px-6 py-4 whitespace-nowrap">
                  <div className="text-sm text-gray-700">
                    {item?.monto_minimo ? `Gs. ${Number(item.monto_minimo).toLocaleString("es-PY")}` : "-"}
                  </div>
                </td> */}

                {/* <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex flex-col text-sm text-gray-700">
                    <span>Total: {item?.stock_total ?? "-"}</span>
                    <span>Usado: {item?.stock_usado ?? "-"}</span>
                    <span>Disponible: {item?.stock_disponible ?? "-"}</span>
                  </div>
                </td> */}

                {/* <td className="px-6 py-4 whitespace-nowrap">
                  <span className="inline-flex rounded-full bg-amber-100 px-2.5 py-1 text-xs font-semibold text-amber-800">
                    {item?.estado || "-"}
                  </span>
                </td> */}

                <td className="px-6 py-4 whitespace-nowrap">
                  <span className={`inline-flex rounded-full px-2.5 py-1 text-xs font-semibold ${item?.obsequio?.activo ? "bg-emerald-100 text-emerald-800" : "bg-gray-100 text-gray-700"}`}>
                    {item?.obsequio?.activo ? "Sí" : "No"}
                  </span>
                </td>

                <td className="px-6 py-4 whitespace-nowrap">
                  <div className="flex items-center gap-2">

                    {/* <button className="p-1 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer" title={item?.activo ? "Desactivar" : "Activar"}
                      onClick={() => handleToggle(item)}
                    >
                      {item?.activo ?
                        <ToggleRight className="w-4 h-4 text-gray-500" /> :
                        <ToggleLeft className="w-4 h-4 text-gray-500" />
                      }
                    </button> */}



                    <button className="p-1 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer" title="Ver"
                      onClick={() => handleVerObsequio(item)}
                    >
                      <Eye className="w-4 h-4 text-gray-500" />
                    </button>

                    <button className="p-1 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer" title="Editar"
                      onClick={() => handleEditarItem(item)}
                    >
                      <Edit className="w-4 h-4 text-gray-500" />
                    </button>

                     <button className="p-1 hover:bg-gray-100 rounded-lg transition-colors cursor-pointer" title="Descargar"
                      onClick={() => handleOpenModalExcel(item?.id)}
                    >
                      <ArrowDownToLineIcon className="w-4 h-4 text-gray-500" />
                    </button>
                  </div>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Si no hay datos */}
      {data.length === 0 && (
        <div className="text-center py-12">
          <div className="text-gray-500">
            No hay obsequios para mostrar.
          </div>
        </div>
      )}

      {/* Paginación */}
      {metaPaginacion && metaPaginacion.total > 0 && (
        <div className="px-6 py-4 border-t border-gray-200 bg-gray-50">
          <div className="flex items-center justify-between">
            {/* Info de página e índice */}
            <div className="flex items-center gap-4">
              <div className="text-sm text-gray-700">
                Mostrando <span className="font-medium">{((metaPaginacion.current_page - 1) * metaPaginacion.per_page) + 1}</span> a{" "}
                <span className="font-medium">
                  {Math.min(metaPaginacion.current_page * metaPaginacion.per_page, metaPaginacion.total)}
                </span> de{" "}
                <span className="font-medium">{metaPaginacion.total}</span> obsequios
              </div>

              {/* Selector de cantidad por página */}
              <div className="flex items-center gap-2">
                <span className="text-sm text-gray-600">Mostrar:</span>
                <select
                  value={perPage}
                  onChange={(e) => onPerPageChange && onPerPageChange(Number(e.target.value))}
                  className="border border-gray-300 rounded px-2 py-1 text-sm focus:outline-none focus:ring-1 focus:ring-blue-500"
                >
                  <option value={5}>5</option>
                  <option value={10}>10</option>
                  <option value={15}>15</option>
                  <option value={20}>20</option>
                  <option value={50}>50</option>
                </select>
                <span className="text-sm text-gray-600">por página</span>
              </div>
            </div>

            {/* Índice de páginas y navegación */}
            <div className="flex items-center gap-4">
              {/* Índice de páginas */}
              <div className="text-sm text-gray-700">
                Página <span className="font-medium">{metaPaginacion.current_page}</span> de{" "}
                <span className="font-medium">{metaPaginacion.last_page}</span>
              </div>

              {/* Botones de navegación */}
              <div className="flex items-center gap-2">
                <button
                  onClick={() => onPageChange && onPageChange(1)}
                  disabled={metaPaginacion.current_page === 1}
                  className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Primera
                </button>
                <button
                  onClick={() => onPageChange && onPageChange(metaPaginacion.current_page - 1)}
                  disabled={metaPaginacion.current_page === 1}
                  className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Anterior
                </button>
                <button
                  onClick={() => onPageChange && onPageChange(metaPaginacion.current_page + 1)}
                  disabled={metaPaginacion.current_page === metaPaginacion.last_page}
                  className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Siguiente
                </button>
                <button
                  onClick={() => onPageChange && onPageChange(metaPaginacion.last_page)}
                  disabled={metaPaginacion.current_page === metaPaginacion.last_page}
                  className="px-3 py-1 text-sm border border-gray-300 rounded hover:bg-gray-100 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  Última
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}